import { forwardRef } from 'react';
import MaterialBox, { BoxProps } from '@mui/material/Box';

export const Box = forwardRef<HTMLDivElement, BoxProps>((props, ref) => {
    return <MaterialBox ref={ref} data-testid={'Box-container'} {...props} />;
});

export default Box;
